import PersonAvailabilitySummary from './PersonAvailabilitySummary';

export default PersonAvailabilitySummary;
